import { useTranslation } from "react-i18next";
import { serviceHighlights } from "@/mocks/siteData";
import { waLink, telLink } from "@/lib/links";
import SectionHeading from "@/components/feature/SectionHeading";

export default function ServiceCenterSection() {
  const { t } = useTranslation();

  return (
    <section id="service" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-lg overflow-hidden h-[360px] md:h-[520px]">
              <img
                alt="Arman Delivery service center workshop with mechanics"
                className="w-full h-full object-cover object-top"
                src="https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20clean%20modern%20motorcycle%20and%20scooter%20service%20center%20workshop%20with%20mechanics%20working%20on%20bikes%2C%20organized%20tool%20wall%2C%20shelves%20of%20spare%20parts%2C%20warm%20amber%20industrial%20lighting%2C%20professional%20automotive%20workshop%20atmosphere%2C%20photorealistic%2C%20sharp%20details%2C%20editorial%20quality&width=900&height=1100&seq=arman-service-center-v2&orientation=portrait&nocache=true"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
            </div>

            <div className="absolute -bottom-6 -right-6 bg-background-50 border border-background-200 rounded-lg p-6 max-w-[240px] hidden md:block">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-timer-flash-fill text-2xl w-6 h-6 flex items-center justify-center" />
                </div>
                <div>
                  <div className="font-heading font-extrabold text-foreground-900 text-2xl leading-none">
                    {t("service.turnaround")}
                  </div>
                  <div className="text-foreground-500 text-xs font-medium mt-1">{t("service.turnaroundLabel")}</div>
                </div>
              </div>
            </div>

            <div className="absolute -top-6 -left-6 bg-background-50 border border-background-200 rounded-lg p-5 hidden md:block">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-lg bg-foreground-900 text-primary-400 flex items-center justify-center">
                  <i className="ri-award-fill text-2xl w-6 h-6 flex items-center justify-center" />
                </div>
                <div>
                  <div className="font-heading font-extrabold text-foreground-900 text-2xl leading-none">4.9 ★</div>
                  <div className="text-foreground-500 text-xs font-medium mt-1">{t("service.rating")}</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <SectionHeading
              align="left"
              eyebrow={t("service.eyebrow")}
              title={
                <>
                  {t("service.title1")}
                  <br />
                  {t("service.title2")}
                </>
              }
              subtitle={t("service.subtitle")}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {serviceHighlights.map((item) => (
                <div key={item.id} className="flex gap-4">
                  <div className="w-11 h-11 shrink-0 rounded-lg bg-background-100 border border-background-200 text-primary-700 flex items-center justify-center">
                    <i className={`${item.icon} text-xl w-6 h-6 flex items-center justify-center`} />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-foreground-900 text-base">
                      {t(`service.${item.id}.title`)}
                    </h3>
                    <p className="mt-1 text-foreground-500 text-sm leading-relaxed">
                      {t(`service.${item.id}.description`)}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <a
                href={waLink(t("wa.service"))}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-6 py-3.5 rounded-md whitespace-nowrap cursor-pointer transition"
              >
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
                {t("service.bookBtn")}
              </a>
              <a
                href={telLink}
                className="inline-flex items-center justify-center gap-2 bg-background-50 border border-background-300 text-foreground-900 font-semibold px-6 py-3.5 rounded-md whitespace-nowrap cursor-pointer hover:border-foreground-900 transition"
              >
                <i className="ri-phone-fill w-4 h-4 flex items-center justify-center" />
                {t("service.callBtn")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}